import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2071,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 95,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 11,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jhk5lzc3_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dg88tynm_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ddguem7j_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/g9ho5jpj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qkfa1owo_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wim55k6q_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jlusu5ui_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0q46jmee_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Lessons"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 60,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/te40qdpy_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7hchg4ws_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tqf2brrv_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kxujxzxx_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gx5hn1q1_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/x0sb9xiu_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7ghw2xcy_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n4v21w7k_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/na2awp8b_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ngxs3qjp_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Lessons"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 41,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 36,
							}} >
							{"Explore all lessons."}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"List of Lessons"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 3,
									marginBottom: 28,
									gap: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dr0m7g6r_expires_30_days.png"} 
									style={{
										width: 9,
										height: 22,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Lesson List"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											paddingTop: 21,
											paddingBottom: 4,
											gap: 7,
											backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/06ozwm61_expires_30_days.png)',
											backgroundSize: "cover",
											backgroundPosition: "center",
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ywr5wdrv_expires_30_days.png"} 
												style={{
													width: 19,
													height: 19,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												marginLeft: 25,
												gap: 2,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iuznv9ff_expires_30_days.png"} 
												style={{
													width: 8,
													height: 8,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 8,
													fontWeight: "bold",
												}} >
												{"10:45"}
											</span>
										</div>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Understanding Market Research"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Video (10 min)"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p2vgrjy8_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"Completed"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 113,
										paddingRight: 113,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Review Lesson"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/c7g8pqr1_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2homo7v8_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Business Planning Strategies"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/444mjqhd_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#EEBD10",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"In Progress"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 130,
										paddingRight: 130,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Continue"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/374ebpf4_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 24,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f7dir36g_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vavxxu1t_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"Not Started"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 127,
										paddingRight: 127,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Start now"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gq1gwfna_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<button 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#E6F7FD",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 109,
									paddingRight: 109,
									gap: 9,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#00AEEF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Browse All Lessons"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tjdke7n9_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</button>
						</div>
						<div 
							style={{
								width: 1,
								height: 715,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Lesson Details"}
							</span>
							<div 
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 24,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										paddingRight: 3,
										marginRight: 255,
										gap: 2,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9nz4l9lx_expires_30_days.png"} 
										style={{
											width: 9,
											height: 22,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
										}} >
										{"Lesson Details"}
									</span>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										paddingRight: 2,
										gap: 2,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/h5bgkd0q_expires_30_days.png"} 
										style={{
											width: 9,
											height: 22,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
										}} >
										{"Lesson Title & Summary"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 28,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/atujck3d_expires_30_days.png"} 
										style={{
											width: 362,
											height: 121,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Lesson Type"}
									</span>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Understanding Market Research"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginBottom: 19,
											width: 294,
										}} >
										{"This lesson covers essential market research techniques to identify customer needs and analyze competition."}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FEF0E9",
											borderRadius: 8,
											paddingTop: 10,
											paddingBottom: 10,
											paddingLeft: 12,
											paddingRight: 12,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d0yg31kf_expires_30_days.png"} 
											style={{
												width: 25,
												height: 25,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												gap: 4,
											}}>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
												}} >
												{"Completion Time"}
											</span>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Approx. 15 min"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 16,
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 3,
										}} >
										{"Quiz Lesson"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/63z5vije_expires_30_days.png"} 
										style={{
											width: 14,
											height: 14,
											marginBottom: 7,
											marginLeft: 332,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											width: 362,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 8,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/icju4dfy_expires_30_days.png"} 
										style={{
											width: 25,
											height: 25,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Lesson Progress"}
										</span>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Completed 25%"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 6,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginRight: 356,
									}} >
									{"Lesson"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pehvw6ky_expires_30_days.png"} 
									style={{
										width: 9,
										height: 22,
										marginRight: 2,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Ask Giia (AI Mentor)"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 5,
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 24,
									}}>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Quick Quiz: Identify Target Audience"}
									</span>
									<div 
										style={{
											width: 362,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 12,
										paddingBottom: 12,
										paddingLeft: 28,
										paddingRight: 28,
										marginTop: 14,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 2,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4n5uu3zd_expires_30_days.png"} 
											style={{
												width: 25,
												height: 25,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#F36421",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Have a question? Ask Giia!"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/df5bvcn5_expires_30_days.png"} 
										style={{
											width: 7,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginRight: 225,
									}} >
									{"Question: 1/10"}
								</span>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Correct: 0"}
								</span>
							</div>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 16,
									width: 315,
								}} >
								{"Which of the following is an example of primary market research?"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 16,
									gap: 12,
								}}>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Conducting customer interviews"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 16,
									gap: 12,
								}}>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Reading competitor reports"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 23,
									gap: 12,
								}}>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Using government census data"}
								</span>
							</div>
							<button 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#E6F7FD",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 114,
									paddingRight: 114,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bkfzpoxs_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										marginRight: 6,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#00AEEF",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 9,
									}} >
									{"Next Question"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mmzuthj3_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}